<template>
  <div class="page">
    <mt-header title class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="container" style="padding: 16px">
      <div class="sign-container">
        <div :class="{
          'flex dl_font1_color dl_margin1_top': true,
          reverse: signType === 'email',
        }">
        <div class="small" @click="changeType('phone')">
          {{ $t("手机注册") }}
        </div>
        <div class="small" @click="changeType('email')">
          {{ $t("邮箱登录") }}
        </div>
      </div>
      <div v-if="signType === 'phone'" class="area-wrap">
        <div class="area" @click="popupVisible = true">
          +{{ areacode }}
          <img src="../assets/img/login_ico_xia.png" alt />
        </div>
        <mt-field :placeholder="$t('请填写手机号')" class="dl_margin4_top w_short" v-model="mobileNum">
          <Code @click.native="sendCode" ref="code"></Code>
        </mt-field>
      </div>
      <mt-field v-else :placeholder="$t('请填写邮箱号')" class="dl_margin4_top w_short" v-model="email">
        <Code @click.native="sendCode" ref="code"></Code>
      </mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('验证码')" class="dl_margin4_top" v-model="code"></mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('设置密码')" class="dl_margin4_top" type="password" v-model="password"></mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('再次输入')" class="dl_margin4_top" type="password" v-model="repassword"></mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('邀请码')" class="dl_margin4_top" v-model="invitecode"></mt-field>
      <div class="dl_line"></div>
      <mt-button type="primary" class="dl_margin5_top" size="large" @click="doRegister">{{ $t("注册") }}</mt-button>
      </div>
      <div class="dl_main_color dl_bottom" style="font-size: 15px">
        <router-link to="/login" class="btn">{{
          $t("已有账号，去登录")
        }}</router-link>
      </div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom">
      <select-area @onChange="onChangeArea" />
    </mt-popup>

    <ImageVerify scene="register" :username="signType == 'phone' ? areacode + '-' + mobileNum : email" ref="imageverify"
      @imageCallback="imageCallback"></ImageVerify>
  </div>
</template>

<script>
import SelectArea from "@/components/SelectArea";
import ImageVerify from "@/components/ImageVerify.vue";
import { validateEmpty, validatePwd } from "@/utils/validate";
import { setToken } from "@/utils/auth";
import { Toast } from "mint-ui";
import { httpSendMobileCode, httpDoRegister } from "@/api/login";
import Code from "@/components/Code";
import { loginIn } from "@/utils/index";
export default {
  name: "Register",
  components: { Toast, Code, SelectArea, ImageVerify },
  data() {
    return {
      mobileNum: "",
      password: "",
      repassword: "",
      code: "",
      invitecode: "",
      popupVisible: false,
      areacode: "852",
      signType: "phone",
      email: "",
    };
  },
  activated() {
    this.mobileNum = "";
    this.password = "";
    this.repassword = "";
    this.code = "";
    this.invitecode = "";
    this.popupVisible = false;
    this.areacode = "852";
    this.signType = "phone";
    this.email = "";
  },
  methods: {
    goback: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    sendCode: function () {
      if (validateEmpty(this.mobileNum) && validateEmpty(this.email)) {
        Toast(this.$t("empty"));
        return;
      }
      this.$refs.imageverify.run()
      // const p = {
      //   username:
      //     this.signType === "phone"
      //       ? this.areacode + "-" + this.mobileNum
      //       : this.email,
      //   scene: "register",
      // };
      // httpSendMobileCode(p)
      //   .then((res) => {
      //     Toast(res.msg);
      //     this.$refs.code.run();

      //   })
      //   .catch((res) => {
      //     console.log(res);
      //   });
    },
    imageCallback() {

      this.$refs.code.run();
    },
    doRegister: function () {
      if (
        validateEmpty(this.code) ||
        validateEmpty(this.repassword) ||
        validateEmpty(this.password)
      ) {
        Toast(this.$t("empty"));
        return;
      }
      if (this.password != this.repassword) {
        Toast(this.$t("noequal"));
        return;
      }
      if (!validatePwd(this.password)) {
        // 如果密码不符合
        Toast(this.$t("wrongpwd"));
        return;
      }
      if (this.invitecode && this.invitecode.length != 6) {
        Toast(this.$t("invite"));
        return;
      }

      const p = {
        username:
          this.signType === "phone"
            ? this.areacode + "-" + this.mobileNum
            : this.email,
        password: this.password,
        verification_code: this.code,
        invitation_code: this.invitecode,
      };
      httpDoRegister(p)
        .then((res) => {
          Toast({ message: res.msg, duration: 8000 });
          this.$router.push("/login");
          loginIn(res.data.token);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    onChangeArea(value) {
      this.popupVisible = false;
      this.areacode = value;
    },
    changeType(type) {
      this.mobileNum = "";
      this.email = "";
      this.signType = type;
    },
  },

};
</script>
<style>
.mint-field.w_short .mint-cell-title {
  width: 45px !important;
}

.mint-field.w_short .mint-cell-title .mint-cell-text {
  margin-left: 0;
}
</style>
<style scoped>
.container {
  padding: 10px;
}

.forget_pass {
  font-size: 16px;
  margin: 25px 0px;
}

a {
  color: #879baa;
}

.btn {
  color: #1e86db;
}

.mint-button--primary {
  background-color: #1e87d9;
}

.dl_bottom {
  position: fixed;
  bottom: 20px;
}

.mint-cell {
  min-height: 40px;
}

.dl_line {
  padding: 0 10px;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  line-height: 1;
  font-size: 14px;
  color: #1e87d9;
}

.flex.reverse {
  flex-direction: row-reverse;
}

.flex .small {
  cursor: pointer;
}

.flex .small:first-child,
.flex.reverse .small:last-child {
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
}

.flex.reverse .small:first-child {
  font-size: 1em;
  font-weight: normal;
  color: #1e87d9;
}

.sign-container {
  background-color: #fff;
  position: relative;
  z-index: 10;
  margin-bottom: 80px;
}
.page {
  height: 100%;
  overflow-y: auto;
}
</style>
